export default __webpack_public_path__ + "static/media/arrowUp.6e8dda44.svg";